import { render, staticRenderFns } from "./NbnAppointmentManagement.vue?vue&type=template&id=566bfbd9&scoped=true"
import script from "./NbnAppointmentManagement.vue?vue&type=script&lang=js"
export * from "./NbnAppointmentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566bfbd9",
  null
  
)

export default component.exports